// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {ErrorPageComponent} from './views/theme/content/error-page/error-page.component';
// Auth
import {AuthGuard} from './core/auth';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {environment} from '../environments/environment';

const routes: Routes = [
    {path: 'auth', loadChildren: () => import('../app/views/pages/auth/auth.module').then((m) => m.AuthModule)},

    {
        path: '',
        component: BaseComponent,
        canActivate: [AuthGuard],
        // canActivateChild: [NgxPermissionsGuard],
        // canLoad: [NgxPermissionsGuard],
        children: [
            {
                path: 'home',
                data: {
                    permissions: {
                        except: []
                    }
                },
                loadChildren: () => import('../app/views/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            {
                path: 'profile',
                data: {
                    permissions: {
                        except: []
                    }
                },
                loadChildren: () => import('./views/pages/user-detail/user-detail.module').then((m) => m.UserDetailModule),
            },
            {
                path: 'user-management',
                data: {
                    permissions: {
                        only: ['GetUsers']
                    }
                },
                loadChildren: () =>
                    import('../app/views/pages/user-management/user-management.module').then((m) => m.UserManagementModule),
            },
            {
                path: 'career-management',
                data: {
                    permissions: {
                        except: []
                    }
                },
                loadChildren: () =>
                    import('../app/views/pages/career-management/career-management.module').then((m) => m.CareerManagementModule),
            },
            {
                path: 'card-applications',
                data: {
                    permissions: {
                        except: []
                    }
                },
                loadChildren: () =>
                    import('../app/views/pages/card-application/card-application.module').then((m) => m.CardApplicationModule),
            },
            {
                path: 'edevlet-transactions',
                data: {
                    permissions: {
                        except: []
                    }
                },
                // tslint:disable-next-line:max-line-length
                loadChildren: () => import('../app/views/pages/edevlet-transactions/edevlet-transactions.module').then((m) => m.EdevletTransactionsModule),
            },
            {
                path: 'system',
                data: {
                    permissions: {
                        only: ['GetLogs']
                    }
                },
                loadChildren: () => import('../app/views/pages/mbs-system/mbs-system.module').then((m) => m.MbsSystemModule),
            },
            {
                path: 'error/403',
                component: ErrorPageComponent,
                data: {
                    type: 'error-v6',
                    code: 403,
                    title: '403... Access forbidden',
                    desc: 'Looks like you don"t have permission to access for requested page.',
                    permissions: {
                        except: []
                    }
                },
            },
            {path: 'error/:type', component: ErrorPageComponent},
            {path: '', redirectTo: 'home', pathMatch: 'full'},
            {path: '**', redirectTo: 'home', pathMatch: 'full'},
        ],
    },

    {path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: environment.production && environment.local, relativeLinkResolution: 'legacy' })],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
